import { create } from "apisauce";
import { apiCrudFactory } from "elentari";
import * as R from "ramda";

const productionUrl = process.env.REACT_APP_API_URL;

const baseURL =
  process.env.NODE_ENV === "development"
    ? "https://api.avaliare.homologacao.eurekahomolog.xyz/"
    : productionUrl;

const AUTH_HEADER = "X-Auth-Token";
const api = create({
  baseURL: baseURL,
});

const _ibgeApi = create({
  baseURL: "https://servicodados.ibge.gov.br/api/v1/",
});
export const ibgeApi = {
  getMunicipios: () => _ibgeApi.get("localidades/municipios"),
};

const defaultFilter = {
  where: {
    removed: false,
  },
};

const sendFormData = (url, formData) =>
  api.post(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

const createCrud = apiCrudFactory({ api, defaultFilter });
export const login = (credentials) => api.post("usuarios/login", credentials);
export const recoverPassword = (email) => api.post("recuperar-senha", email);
export const resetPassword = (data) =>
  api.post(`resetar-senha/${data.token}`, { senha: data.senha });
export const grupoAlimentarApi = createCrud("grupos-alimentares");
export const receitaGrupoAlimentarApi = createCrud(
  "receitas-grupos-alimentares"
);
export const tipoRefeicaoApi = createCrud("refeicao-tipos");
export const refeicaoReceitaApi = createCrud("refeicao-receitas");
export const clienteApi = {
  uploadImagemPerfil: (id, formData) =>
    sendFormData(`/cliente-usuarios/${id}/thumbnail/upload`, formData),
  deleteImagemPerfil: (id) =>
    api.delete(`/cliente-usuarios/${id}/thumbnail/upload`),
  ...createCrud("cliente-usuarios"),
  getOnlyWithFcmToken: (filter = {}) =>
    api.get("/cliente-usuarios/fcm", {
      filter: R.mergeDeepWith(R.join, defaultFilter, filter),
    }),
  getLastClienteAval: (id) =>
    api.get(`/avaliacoes/${id}/last?only_with_images=false`),
};
export const cardapioApi = {
  ...createCrud("cardapios"),
  duplicate: (id) => api.post(`cardapios/${id}/duplicate`),
  notify: (id, message) => api.patch(`/cardapios/${id}/notificate`, message),
};
export const treinoObjetivoApi = createCrud("treino-objetivos");
export const servicosApi = {
  ...createCrud("servicos"),
  uploadIcon: (id, formData) =>
    sendFormData(`/servicos/${id}/upload`, formData),
};
export const exerciciosApi = {
  ...createCrud("exercicios"),
  uploadGif: (id, formData) =>
    sendFormData(`exercicios/${id}/upload`, formData),
};
export const dicasApi = {
  ...createCrud("dicas"),
  uploadImagem: (id, formData) => sendFormData(`/dicas/${id}/upload`, formData),
};
export const inbodyApi = {
  ...createCrud("inbodies"),
  uploadImages: (id, formData) =>
    sendFormData(`/inbodies/${id}/upload`, formData),
  notify: (id, message) => api.patch(`/inbodies/${id}/notificate`, message),
};
export const secaApi = {
  ...createCrud("seca"),
  uploadImages: (id, formData) => sendFormData(`/seca/${id}/upload`, formData),
  notify: (id, message) => api.patch(`/secas/${id}/notificate`, message),
};
export const antropometriaApi = {
  ...createCrud("antropometria"),
  notify: (id, message) =>
    api.patch(`/antropometria/${id}/notificate`, message),
};
export const clienteServicosApi = createCrud("clientes-servicos");
export const treinoApi = {
  ...createCrud("treinos"),
  duplicate: (id) => api.post(`treinos/${id}/duplicate`),
};
export const clienteTreinoApi = {
  ...createCrud("cliente-treinos"),
  notify: (id, data) => api.patch(`/cliente-treinos/${id}/notificate`, data),
};
export const treinoExercicioApi = createCrud("treino-exercicios");
export const receitaApi = createCrud("receitas", {
  transformers: {
    getOne: (data) => {
      const copy = { ...data };
      delete copy.grupos;
      return copy;
    },
  },
});
export const refeicaoApi = {
  ...createCrud("refeicoes"),
  update: (id, data) => api.put(`refeicoes/${id}`, data),
  getList: (cardapioId, params) =>
    api.get(`cardapios/${cardapioId}/refeicoes`, params),
};
export const notificacoesApi = {
  ...createCrud("notificacoes"),
  send: (id) => api.patch(`notificacoes/${id}/send`),
  queryCount: (id) => api.get(`notificacoes/${id}/count`),
};
export const fcmApi = {
  getFcmsByClientId: (clienteId) => api.get(`fcm-tokens/${clienteId}/client`),
};
export const setToken = (token) => api.setHeader(AUTH_HEADER, token);
export const testeRecuperacaoApi = createCrud("teste-recuperacao");
export const bodymetrixAvaliacaoApi = createCrud("bodymetrix-avaliacao");
export const bodymetrixRegiaoAvaliacaoApi = {
  ...createCrud("bodymetrix-regiao-avaliacao"),
  uploadImage: (id, formData) =>
    sendFormData(`/regiao-avaliacao/${id}/image/upload`, formData),
};
export const bodymetrixRegiaoApi = createCrud("bodymetrix-regiao");
export const indicadorAvalApi = {
  ...createCrud("indicador-aval"),
  getTipoExercicio: () => api.get("/indicador-aval/tipo-exercicio"),
  getClientIndicadorResult: (params) =>
    api.get(`/indicador-aval/aval`, {
      filter: {
        ...params,
      },
    }),
};
export const avalAvaliacaoApi = {
  ...createCrud("aval-avaliacao"),
  notify: (id, message) =>
    api.patch(`/aval-avaliacao/${id}/notificate`, message),
};

export const indicadorAvalAvaliacaoApi = createCrud("indicador-aval-avaliacao");

export const evalAptActivityApi = createCrud("eval-apt-activity");
export const evalAptRangeApi = createCrud("eval-apt-range");
export const evalAptInstanceApi = createCrud("eval-apt-instance");
